/**
 * @generated SignedSource<<06caddbfd76bad8b57c30dc9eb47a6d3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TransferAppDestinationSelectorQuery$variables = {
  appId: string;
};
export type TransferAppDestinationSelectorQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly tenant: {
        readonly __typename: "Organization";
        readonly id: string;
      } | {
        readonly __typename: "User";
        readonly id: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
    } | null | undefined;
    readonly me: {
      readonly isSuperAdmin: boolean;
      readonly organizations: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"TransferAppDestinationSelectorFragment_organization">;
      }>;
    } | null | undefined;
  };
};
export type TransferAppDestinationSelectorQuery = {
  response: TransferAppDestinationSelectorQuery$data;
  variables: TransferAppDestinationSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSuperAdmin",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageUrl",
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v2/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = [
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransferAppDestinationSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organizations",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "TransferAppDestinationSelectorFragment_organization",
                    "selections": (v3/*:: as any*/),
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*:: as any*/),
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*:: as any*/),
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TransferAppDestinationSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organizations",
                "plural": true,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*:: as any*/),
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*:: as any*/),
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b356526ca98e20c9363005c6f3920e55",
    "id": null,
    "metadata": {},
    "name": "TransferAppDestinationSelectorQuery",
    "operationKind": "query",
    "text": "query TransferAppDestinationSelectorQuery(\n  $appId: ID!\n) {\n  viewer {\n    me {\n      isSuperAdmin\n      organizations {\n        ...TransferAppDestinationSelectorFragment_organization\n        id\n      }\n      id\n    }\n    appById(id: $appId) {\n      tenant {\n        __typename\n        ... on Organization {\n          id\n          __typename\n        }\n        ... on User {\n          id\n          __typename\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment TransferAppDestinationSelectorFragment_organization on Organization {\n  id\n  name\n  slug\n  imageUrl\n}\n"
  }
};
})();

(node as any).hash = "641f74215553a6b72efa5955dcd020f6";

export default node;
